import { type FormItemProps } from 'antd/es/form';
import { FieldArray } from 'formik';
import { get } from 'lodash/fp';
import FormItem from '../../../../components/fields/FormItem';
import { type ColumnsBlockInner, type WebpageFormikValue } from '../shared';
import ColumnTable from './ColumnTable';

export const colSpan = { lg: 8, md: 12, xs: 24 };
export interface ColumnBlockInputArrayProps {
    name: string;
    label?: string;
    labelForAdd?: string;
    itemProps?: Omit<FormItemProps, 'label' | 'meta' | 'required' | 'children'>;
    limit?: number;
    disabled?: boolean;
}

const ColumnListBlock = ({
    name,
    label,
    labelForAdd,
    itemProps,
    limit,
    disabled = false,
    ...props
}: ColumnBlockInputArrayProps) => (
    <FormItem {...itemProps} label={label} name={name}>
        <FieldArray
            name={name}
            render={arrayHelpers => {
                const webpage = arrayHelpers.form.values as WebpageFormikValue;
                const webpageColumn = get(name, webpage) as ColumnsBlockInner[];

                return (
                    <ColumnTable
                        columnTable={webpageColumn}
                        disabled={disabled}
                        name={name}
                        remove={arrayHelpers.remove}
                    />
                );
            }}
        />
    </FormItem>
);

export default ColumnListBlock;
